import { Grid, Typography } from '@mui/material';
import { useCurrentUser } from 'hooks/common';
import React from 'react';
import type { MemorySearchResults } from 'types/Memory';
import { sortByDate } from 'utilities/sort';
import { formatDateAndTime } from 'utilities/time';

type RecentQuestionsTabProps = { memorySearchResults: MemorySearchResults[] };

function RecentQuestionsTab({ memorySearchResults }: RecentQuestionsTabProps) {
  const { currentUserID } = useCurrentUser();
  const currentUserMemorySearchResults = memorySearchResults.filter(
    (results) => results.attributes.createdBy === currentUserID
  );

  const sortedByDate = currentUserMemorySearchResults?.sort((a, b) =>
    sortByDate(b.attributes.createdAt, a.attributes.createdAt)
  );

  const lastThreeRecords = sortedByDate?.slice(0, 3);

  const questionAnswers = lastThreeRecords?.map((search) => {
    return {
      question: search?.attributes.query,
      searchDate: search.attributes.createdAt,
      answer: search?.attributes.text,
    };
  });

  return (
    <Grid container gap={2} style={{ height: '400px', overflow: 'auto' }}>
      {questionAnswers?.map((QA, index) => (
        <Grid
          key={index}
          item
          container
          direction='column'
          padding={2}
          bgcolor={(theme) => theme.palette.bgGray.main}
          borderRadius='10px'
        >
          <Typography fontFamily='mont-semibold'>{QA.question}</Typography>
          <Typography variant='subtitle1'>
            {formatDateAndTime(QA.searchDate)}
          </Typography>
          <Typography>{!!QA.answer ? QA.answer : 'No answer found'}</Typography>
        </Grid>
      ))}
    </Grid>
  );
}

export default RecentQuestionsTab;
